import { getLocale } from "@novel/shared/utils/getLocale";
import TinyTimer from "tiny-timer";

export function createTimer(
    targetDate: Date,
    callback: (timeStr: string) => void,
    interval = 1000,
): () => void {
    const timer = new TinyTimer({ interval });

    const onTick = (ms: number) => {
        callback(renderTime(ms));
    };
    timer.on("tick", onTick);

    const onDone = () => {
        callback("0:00:00");
    };
    timer.on("done", onDone);

    timer.start(+new Date(targetDate) - Date.now());

    return () => {
        timer.off("tick", onTick);
        timer.off("done", onDone);
        timer.stop();
    };
}

const relativeDateFormat = new Intl.RelativeTimeFormat(getLocale(), {
    style: "narrow",
});

const oneDayInMs = 24 * 60 * 60 * 1000;
const renderTime = (ms: number) => {
    const days = Math.floor(ms / oneDayInMs);
    const remainder = ms % oneDayInMs;
    let msString = new Date(remainder).toISOString().slice(11, -5);
    if (msString[0] === "0") {
        msString = msString.slice(1);
    }

    return `${relativeDateFormat.format(days, "day")} ${msString}`;
};
